import {styled} from '@esgi/ui/theme';
import {Tabs} from '../../../../../tabs';

export const TabContent = styled(Tabs.TabContent, {
	display: 'flex',
	flexDirection: 'column',
	gap: 20,
	overflow: 'hidden',
});
